var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Tags',{staticClass:"mt-3",attrs:{"compact":true,"record":_vm.record}}),(_vm.getCurrentProcessType !== 'private')?_c('p',[_vm._v(" "+_vm._s(_vm.$t('processes.sidebar.tags_description'))+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }